import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticle from './components/FeaturedArticle';
import ArticleGrid from './components/ArticleGrid';
import CTASection from './components/CTASection';
import TrustSafety from './components/TrustSafety';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://litbuyspreadsheets.pics';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Litbuy Spreadsheet Guide & Resources',
  url: siteUrl,
  description: 'Comprehensive Litbuy Spreadsheet guides, tutorials, comparisons, and resources. Learn how to use Litbuy Spreadsheet for product management, data organization, and workflow optimization.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <title>Litbuy Spreadsheet Guide, Tutorials &amp; Resources | litbuyspreadsheets.pics</title>
      <meta name="description" content="Comprehensive Litbuy Spreadsheet guides, tutorials, comparisons, and resources. Learn how to use Litbuy Spreadsheet for product management, data organization, and workflow optimization. Expert tips for beginners and advanced users." />
      <meta name="keywords" content="litbuy spreadsheet, spreadsheet guide, product management spreadsheet, data organization, spreadsheet tutorials, litbuy spreadsheet review" />
      <link rel="canonical" href={`${siteUrl}/`} />
      <meta property="og:title" content="Litbuy Spreadsheet Guide, Tutorials &amp; Resources" />
      <meta property="og:description" content="Comprehensive Litbuy Spreadsheet guides, tutorials, comparisons, and resources. Learn how to use Litbuy Spreadsheet for product management, data organization, and workflow optimization." />
      <meta property="og:url" content={`${siteUrl}/`} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Litbuy Spreadsheet Guide, Tutorials &amp; Resources" />
      <meta name="twitter:description" content="Comprehensive Litbuy Spreadsheet guides, tutorials, comparisons, and resources. Expert tips for beginners and advanced users." />
      <JsonLd data={websiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticle />
        <ArticleGrid />
        <CTASection />
        <TrustSafety />
      </main>
      <Footer />
    </div>
  );
}